import { render, staticRenderFns } from "./UiRadioGroup.vue?vue&type=template&id=543a2aee&"
import script from "./UiRadioGroup.vue?vue&type=script&lang=js&"
export * from "./UiRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./UiRadioGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports